import { render, staticRenderFns } from "./PackageModal.vue?vue&type=template&id=f8022a5a&"
import script from "./PackageModal.vue?vue&type=script&lang=js&"
export * from "./PackageModal.vue?vue&type=script&lang=js&"
import style0 from "./PackageModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports